import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../../../../../../src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-horizontal-nav-item',
  standalone: true,
  imports: [MaterialModule, TablerIconsModule, CommonModule, RouterModule],
  templateUrl: './nav-item.component.html'
})
export class AppHorizontalNavItemComponent {
  @Input() depth: any;
  @Input() item: any;

  constructor() {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  // Stable kebab-case id for Selenium nav targets 19/10/2026 DW
  navItemAutomationId(suffix = ''): string {
    const raw = String(this.item?.route ?? this.item?.displayName ?? 'item');
    const slug = raw
      .replace(/^\//, '')
      .replace(/\//g, '-')
      .replace(/\s+/g, '-')
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '');
    return suffix ? `nav-${slug}-${suffix}` : `nav-${slug}-link`;
  }
}
